import React from 'react'
import { MainWrap } from '../../utilities/Shared'

const EOM = () => {

    console.log('ran Cron')


  return (
    <MainWrap>

eom

    </MainWrap>
  )
}

export default EOM